const CONSTANTS = {
  LOG_EVENT: 'dispatchEvent',
  amplitude: {
    logEvent: 'amplitudeLogEvent',
  },
  gAnalytics: {
    logEvent: 'analyticsLogEvent',
  },
}

export default CONSTANTS
